module.exports = __webpack_public_path__ + "img/Stemness-BRCA_10X_Section1.ba9feaaf.png";